const toPx = (value = 0) => {
  return value === 0 ? 0 : `${value}px`;
};

export default toPx;
